import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../components/Layout/layout";
import { HeaderType } from "../../../components/Layout/header";
import ProtectedRoute from "../../../../Auth/components/ProtectedRoute";
import SystemNotificationsManage from "../../../components/systemNotifications/SystemNotificationsManage";

const SystemNotificationsContainer = () => (
  <ProtectedRoute>
    <main>
      <Helmet title="Notifications" />
      <Layout headerType={HeaderType.superadmin}>
        <SystemNotificationsManage />
      </Layout>
    </main>
  </ProtectedRoute>
);

export default SystemNotificationsContainer;
